import { useAccountStore } from "features/Account/store/useAccountStore";
import { LazyLoadWrapper } from "features/Common/LazyLoadWrapper/LazyLoadWrapper";
import { checkIsArrayEmpty } from "features/Common/modules/DataTypes/utils/Array.utils";
import { WhiteLabellingPurchaseModal } from "features/MySubscriptions/constants/MySubscriptions.lazy";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import React from "react";

export const WhitelabelPlanModalWrapper = withComponentLibraryTheme(() => {
  const whitelabelPlans = useAccountStore((state) => state.whitelabelPlans);
  const showWhitelabelPlansModal = useAccountStore(
    (state) => state.showWhitelabelPlansModal
  );
  const setShowWhitelabelPlansModal = useAccountStore(
    (state) => state.setShowWhitelabelPlansModal
  );
  const showPlansModal =
    showWhitelabelPlansModal && !checkIsArrayEmpty(whitelabelPlans);
  return (
    <LazyLoadWrapper loadingCondition={showPlansModal}>
      <WhiteLabellingPurchaseModal
        open={showPlansModal}
        onClose={() => setShowWhitelabelPlansModal(false)}
        plans={whitelabelPlans}
        redirectToCartPage
      />
    </LazyLoadWrapper>
  );
});
